import * as React from 'react';
import { connect } from 'react-redux';
import { flatMap } from 'lodash';

import { IPackageListingAppState } from '../../redux-state';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { IPerformance, IPackage } from '../../custom/classes/production';
import ListPackageView from '../../views/library/list-package.view';
import { IPackageListingAppSettings } from '../../custom/classes/package-listing-settings';
import { toggleMiniCart, selectPackage, removeItemFromCart } from '../../redux-state/actions/package-listing.actions';
import { getPackagePerformances } from '../../helpers/package-helper';

interface IListPackageExternalProps {
    package: IPackage;
}

interface StateToProps {
    text: IPackageListingAppText;
    settings: IPackageListingAppSettings;
    useUnseatedReserve: boolean;
    selectedPackage: boolean;
    filterFunction: (option) => any;
    numberOfPackagesInList: number;
}

interface DispatchToProps {
    selectPackage: (pkg: IPackage, unseated: boolean) => void;
    removeFromCart: (itemId: number) => void;

}

interface ListPackageViewState {
    showPerformances: boolean;
}

interface ViewProps {
    toggleShowPerformances: () => void;
    packagePerformances: Array<IPerformance>;
}

export type ListPackageProps = IListPackageExternalProps & StateToProps & DispatchToProps;

export type CombinedPackageViewProps = ListPackageProps & ListPackageViewState & ViewProps;

export class ListPackageBase extends React.Component<ListPackageProps, ListPackageViewState, any> {

    constructor(props: ListPackageProps) {
        super(props);
        this.state = {
            showPerformances: false
        };
    }

    render() {
        const allPerf = getPackagePerformances(this.props.package)
        const filteredPerformances = allPerf.filter(this.props.filterFunction);
        if (filteredPerformances.length == 0)
            return null;

        return (
            <ListPackageView {...this.props} {...this.state} packagePerformances={allPerf}
                toggleShowPerformances={this._toggleShowPerformances.bind(this)}

            />
        )
    }

    _toggleShowPerformances = () => {
        this.setState(
            { showPerformances: !(this.state.showPerformances) }
        );
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: IListPackageExternalProps): StateToProps {
    return {
        text: state.packageListingText,
        settings: state.packageListingSettings,
        useUnseatedReserve: state.packageListingSettings.useUnseatedReservation,
        selectedPackage: state.packageListing.cartItems.size > 0 && state.packageListing.cartItems.keys().next().value == ownProps.package.id,
        filterFunction: state.packageListing.filterFunction,
        numberOfPackagesInList: state.packageListing.packages.length
    }
}

function mapDispatchToProps(dispatch, ownProps: ListPackageProps): DispatchToProps {
    return {
        selectPackage: (pkg: IPackage, unseated: boolean) => {
            if (unseated) {
                dispatch(selectPackage(pkg));
            } else {
                window.location.href = `${window["pageData"].smartSeatUrl}fixed/?itemNumber=${pkg.id}`;
            }
            dispatch(toggleMiniCart(true));
        },
        removeFromCart: (itemId: number) => {
            dispatch(removeItemFromCart(itemId));
        }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(ListPackageBase);